<template>
  <div class="configuracion-usuarios py-4" :class="themeClass">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xxl-10 col-xl-11">
          <div class="card shadow-sm border-0">
            <div class="card-header bg-gradient text-white d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-0"><i class="bi bi-people me-2"></i>Usuarios de la Empresa</h3>
                <small class="text-white-50">Gestiona quién puede acceder al facturador asociado a este subdominio</small>
              </div>
              <button class="btn btn-light btn-sm" @click="abrirModalNuevo">
                <i class="bi bi-person-plus me-1"></i> Nuevo usuario
              </button>
            </div>
            <div class="card-body">

              <div v-if="cargando" class="text-center py-5">
                <div class="spinner-border text-primary"></div>
                <p class="text-muted mt-3">Cargando usuarios...</p>
              </div>

              <template v-else>
                <div v-if="mensajeError" class="alert alert-danger d-flex justify-content-between align-items-center">
                  <span>{{ mensajeError }}</span>
                  <button type="button" class="btn-close" @click="mensajeError = ''"></button>
                </div>
                <div v-if="mensajeExito" class="alert alert-success d-flex justify-content-between align-items-center">
                  <span>{{ mensajeExito }}</span>
                  <button type="button" class="btn-close" @click="mensajeExito = ''"></button>
                </div>

                <!-- Barra de búsqueda -->
                <div class="row mb-3 align-items-center">
                  <div class="col-md-5">
                    <div class="input-group">
                      <span class="input-group-text"><i class="bi bi-search"></i></span>
                      <input type="text" class="form-control" v-model="busqueda"
                             placeholder="Buscar por nombre, correo o usuario..." />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <select class="form-select" v-model="filtroRol">
                      <option value="">Todos los roles</option>
                      <option v-for="rol in rolesDisponibles" :key="rol.valor" :value="rol.valor">
                        {{ rol.etiqueta }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <select class="form-select" v-model="filtroEstado">
                      <option value="">Todos los estados</option>
                      <option value="1">Activos</option>
                      <option value="0">Inactivos</option>
                    </select>
                  </div>
                  <div class="col-md-2 text-end">
                    <small class="text-muted">{{ usuariosFiltrados.length }} usuario(s)</small>
                  </div>
                </div>

                <!-- Tabla de usuarios -->
                <div class="table-responsive">
                  <table class="table align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Usuario</th>
                        <th>Correo</th>
                        <th>Rol</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center">Último acceso</th>
                        <th class="text-center" style="width: 120px;">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="usuariosFiltrados.length === 0">
                        <td colspan="6" class="text-center text-muted py-5">
                          <i class="bi bi-people fs-1 d-block mb-2"></i>
                          <span v-if="busqueda || filtroRol || filtroEstado">No hay usuarios que coincidan con los filtros.</span>
                          <span v-else>Aún no hay usuarios registrados. Crea el primero para comenzar.</span>
                        </td>
                      </tr>
                      <tr v-for="usuario in usuariosFiltrados" :key="usuario.id">
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <div class="avatar-circle" :style="{ backgroundColor: colorAvatar(usuario.nombre) }">
                              {{ iniciales(usuario.nombre) }}
                            </div>
                            <div>
                              <div class="fw-semibold">{{ usuario.nombre }}</div>
                              <small class="text-muted">{{ usuario.nombreUsuario || '—' }}</small>
                            </div>
                          </div>
                        </td>
                        <td>{{ usuario.correo }}</td>
                        <td>
                          <span class="badge" :class="badgeRol(usuario.rol)">{{ etiquetaRol(usuario.rol) }}</span>
                        </td>
                        <td class="text-center">
                          <div class="form-check form-switch d-flex justify-content-center">
                            <input class="form-check-input" type="checkbox"
                                   :checked="!!usuario.activo"
                                   @change="toggleEstado(usuario)"
                                   :disabled="usuario.esActualUsuario">
                          </div>
                        </td>
                        <td class="text-center">
                          <small class="text-muted">{{ formatearFecha(usuario.ultimoAcceso) }}</small>
                        </td>
                        <td class="text-center">
                          <button class="btn btn-outline-primary btn-sm me-1" @click="abrirModalEditar(usuario)" title="Editar">
                            <i class="bi bi-pencil"></i>
                          </button>
                          <button class="btn btn-outline-danger btn-sm" @click="confirmarEliminar(usuario)"
                                  :disabled="usuario.esActualUsuario" title="Eliminar">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal crear/editar usuario -->
    <div class="modal fade" :class="{ show: mostrarModal }" :style="{ display: mostrarModal ? 'block' : 'none' }"
         tabindex="-1" @click.self="cerrarModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" :class="themeClass">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="bi bi-person-gear me-2"></i>
              {{ modoEdicion ? 'Editar usuario' : 'Nuevo usuario' }}
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="cerrarModal"></button>
          </div>
          <div class="modal-body">

            <div v-if="errorModal" class="alert alert-danger">{{ errorModal }}</div>

            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nombre completo *</label>
                <input type="text" class="form-control" v-model.trim="formulario.nombre"
                       placeholder="Ej. María González" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Correo electrónico *</label>
                <input type="email" class="form-control" v-model.trim="formulario.correo"
                       placeholder="usuario@empresa.com"
                       :readonly="modoEdicion && formulario.esActualUsuario" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Nombre de usuario</label>
                <input type="text" class="form-control" v-model.trim="formulario.nombreUsuario"
                       placeholder="Opcional — se generará del correo si se deja vacío" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Rol *</label>
                <select class="form-select" v-model="formulario.rol">
                  <option value="">Selecciona un rol...</option>
                  <option v-for="rol in rolesDisponibles" :key="rol.valor" :value="rol.valor">
                    {{ rol.etiqueta }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{ modoEdicion ? 'Nueva contraseña' : 'Contraseña *' }}</label>
                <div class="input-group">
                  <input :type="mostrarClave ? 'text' : 'password'" class="form-control"
                         v-model="formulario.clave"
                         :placeholder="modoEdicion ? 'Deja vacío para no cambiar' : 'Mínimo 8 caracteres'" />
                  <button class="btn btn-outline-secondary" type="button" @click="mostrarClave = !mostrarClave">
                    <i :class="mostrarClave ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </button>
                </div>
                <small class="text-muted" v-if="formulario.clave">
                  {{ indicadorFuerzaClave }}
                </small>
              </div>
              <div class="col-md-6" v-if="formulario.clave">
                <label class="form-label">Confirmar contraseña *</label>
                <input :type="mostrarClave ? 'text' : 'password'" class="form-control"
                       v-model="formulario.confirmarClave"
                       placeholder="Repite la contraseña" />
              </div>
            </div>

            <!-- Descripción de roles -->
            <div class="mt-3 p-3 rounded" style="background: rgba(17,115,212,0.06);" v-if="formulario.rol">
              <small class="text-muted">
                <strong>{{ etiquetaRol(formulario.rol) }}:</strong> {{ descripcionRol(formulario.rol) }}
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="cerrarModal">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="guardarUsuario" :disabled="guardando">
              <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
              {{ modoEdicion ? 'Guardar cambios' : 'Crear usuario' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="mostrarModal"></div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import api from '@/services/api'

export default {
  name: 'ClientConfiguracionUsuarios',
  data() {
    return {
      cargando: true,
      guardando: false,
      mensajeError: '',
      mensajeExito: '',
      busqueda: '',
      filtroRol: '',
      filtroEstado: '',
      usuarios: [],
      mostrarModal: false,
      modoEdicion: false,
      mostrarClave: false,
      errorModal: '',
      formulario: {
        id: null,
        nombre: '',
        correo: '',
        nombreUsuario: '',
        rol: '',
        clave: '',
        confirmarClave: '',
        esActualUsuario: false
      },
      rolesDisponibles: [
        { valor: 'administrador', etiqueta: 'Administrador',  descripcion: 'Acceso completo a todas las funciones del sistema de facturación.' },
        { valor: 'facturador',    etiqueta: 'Facturador',     descripcion: 'Puede emitir facturas, notas de crédito y guías de remisión.' },
        { valor: 'vendedor',      etiqueta: 'Vendedor',       descripcion: 'Acceso a facturación y clientes. Sin acceso a configuración.' },
        { valor: 'contador',      etiqueta: 'Contador',       descripcion: 'Acceso de solo lectura a documentos y reportes para fines contables.' },
        { valor: 'reportes',      etiqueta: 'Solo reportes',  descripcion: 'Únicamente puede consultar reportes y estadísticas.' }
      ]
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    },
    usuariosFiltrados() {
      return this.usuarios.filter(u => {
        const termino = this.busqueda.toLowerCase()
        const coincideTexto = !termino || (
          (u.nombre || '').toLowerCase().includes(termino) ||
          (u.correo || '').toLowerCase().includes(termino) ||
          (u.nombreUsuario || '').toLowerCase().includes(termino)
        )
        const coincideRol    = !this.filtroRol    || u.rol === this.filtroRol
        const coincideEstado = !this.filtroEstado || String(u.activo ? '1' : '0') === this.filtroEstado
        return coincideTexto && coincideRol && coincideEstado
      })
    },
    indicadorFuerzaClave() {
      const clave = this.formulario.clave
      if (!clave) return ''
      if (clave.length < 8) return '⚠️ Muy corta (mínimo 8 caracteres)'
      const tieneNumero  = /[0-9]/.test(clave)
      const tieneMayuscula = /[A-Z]/.test(clave)
      const tieneEspecial  = /[^a-zA-Z0-9]/.test(clave)
      const puntaje = [tieneNumero, tieneMayuscula, tieneEspecial].filter(Boolean).length
      if (puntaje === 3) return '✅ Contraseña fuerte'
      if (puntaje === 2) return '🟡 Contraseña aceptable'
      return '🔴 Contraseña débil — añade números, mayúsculas o símbolos'
    }
  },
  created() {
    this.cargarUsuarios()
  },
  methods: {
    async cargarUsuarios() {
      this.cargando = true
      this.mensajeError = ''
      try {
        const res = await api.get('/configuracion/usuarios')
        const datos = res?.data?.data || res?.data || []
        this.usuarios = Array.isArray(datos) ? datos.map(u => ({
          id:            u.id,
          nombre:        u.nombre || u.name || '',
          correo:        u.correo || u.email || '',
          nombreUsuario: u.nombre_usuario || u.username || '',
          rol:           u.rol || u.role || 'facturador',
          activo:        u.activo !== false && u.is_active !== false,
          ultimoAcceso:  u.ultimo_acceso || u.last_login || null,
          esActualUsuario: !!u.es_actual
        })) : []
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || 'No se pudo cargar la lista de usuarios.'
      } finally {
        this.cargando = false
      }
    },

    abrirModalNuevo() {
      this.modoEdicion = false
      this.errorModal = ''
      this.mostrarClave = false
      this.formulario = { id: null, nombre: '', correo: '', nombreUsuario: '', rol: '', clave: '', confirmarClave: '', esActualUsuario: false }
      this.mostrarModal = true
    },

    abrirModalEditar(usuario) {
      this.modoEdicion = true
      this.errorModal = ''
      this.mostrarClave = false
      this.formulario = {
        id:              usuario.id,
        nombre:          usuario.nombre,
        correo:          usuario.correo,
        nombreUsuario:   usuario.nombreUsuario,
        rol:             usuario.rol,
        clave:           '',
        confirmarClave:  '',
        esActualUsuario: usuario.esActualUsuario
      }
      this.mostrarModal = true
    },

    cerrarModal() {
      this.mostrarModal = false
    },

    async guardarUsuario() {
      this.errorModal = ''

      if (!this.formulario.nombre.trim()) {
        this.errorModal = 'El nombre es obligatorio.'
        return
      }
      if (!this.formulario.correo.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formulario.correo)) {
        this.errorModal = 'Ingresa un correo electrónico válido.'
        return
      }
      if (!this.formulario.rol) {
        this.errorModal = 'Selecciona un rol para el usuario.'
        return
      }
      if (!this.modoEdicion && !this.formulario.clave) {
        this.errorModal = 'La contraseña es obligatoria para un usuario nuevo.'
        return
      }
      if (this.formulario.clave && this.formulario.clave.length < 8) {
        this.errorModal = 'La contraseña debe tener al menos 8 caracteres.'
        return
      }
      if (this.formulario.clave && this.formulario.clave !== this.formulario.confirmarClave) {
        this.errorModal = 'Las contraseñas no coinciden.'
        return
      }

      this.guardando = true
      try {
        const payload = {
          nombre:         this.formulario.nombre,
          correo:         this.formulario.correo,
          nombre_usuario: this.formulario.nombreUsuario,
          rol:            this.formulario.rol
        }
        if (this.formulario.clave) {
          payload.clave = this.formulario.clave
        }

        if (this.modoEdicion) {
          await api.put(`/configuracion/usuarios/${this.formulario.id}`, payload)
          this.mensajeExito = 'Usuario actualizado correctamente.'
        } else {
          await api.post('/configuracion/usuarios', payload)
          this.mensajeExito = 'Usuario creado correctamente.'
        }

        this.cerrarModal()
        await this.cargarUsuarios()
      } catch (error) {
        this.errorModal = error?.response?.data?.error || error?.message || 'No se pudo guardar el usuario.'
      } finally {
        this.guardando = false
      }
    },

    async toggleEstado(usuario) {
      const nuevoEstado = !usuario.activo
      try {
        await api.patch(`/configuracion/usuarios/${usuario.id}/estado`, { activo: nuevoEstado })
        usuario.activo = nuevoEstado
        this.mensajeExito = `Usuario ${nuevoEstado ? 'activado' : 'desactivado'} correctamente.`
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || 'No se pudo cambiar el estado del usuario.'
      }
    },

    async confirmarEliminar(usuario) {
      if (!confirm(`¿Eliminar al usuario "${usuario.nombre}"? Esta acción no se puede deshacer.`)) return
      try {
        await api.delete(`/configuracion/usuarios/${usuario.id}`)
        this.mensajeExito = 'Usuario eliminado correctamente.'
        await this.cargarUsuarios()
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || 'No se pudo eliminar el usuario.'
      }
    },

    etiquetaRol(valor) {
      return this.rolesDisponibles.find(r => r.valor === valor)?.etiqueta || valor
    },

    descripcionRol(valor) {
      return this.rolesDisponibles.find(r => r.valor === valor)?.descripcion || ''
    },

    badgeRol(valor) {
      const mapa = {
        administrador: 'bg-danger',
        facturador:    'bg-primary',
        vendedor:      'bg-success',
        contador:      'bg-info text-dark',
        reportes:      'bg-secondary'
      }
      return mapa[valor] || 'bg-secondary'
    },

    iniciales(nombre) {
      if (!nombre) return '?'
      return nombre.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase()
    },

    colorAvatar(nombre) {
      if (!nombre) return '#6c757d'
      const colores = ['#0d6efd','#198754','#dc3545','#ffc107','#0dcaf0','#6f42c1','#fd7e14']
      const indice = nombre.charCodeAt(0) % colores.length
      return colores[indice]
    },

    formatearFecha(fecha) {
      if (!fecha) return 'Nunca'
      try {
        return new Date(fecha).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' })
      } catch {
        return fecha
      }
    }
  }
}
</script>

<style scoped>
.configuracion-usuarios {
  --primary-color: #1173d4;
  --body-bg: #f5f7fb;
  --card-bg: #ffffff;
  --border-color: rgba(17, 115, 212, 0.1);
  --text-primary: #1f2933;
  --text-secondary: #4a5568;
  background-color: var(--body-bg);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.configuracion-usuarios.dark-theme {
  --body-bg: #0b1320;
  --card-bg: #111d30;
  --border-color: rgba(148, 163, 184, 0.18);
  --text-primary: #e2e8f0;
  --text-secondary: #cbd5f5;
}

.card {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.modal-content {
  background-color: var(--card-bg);
  color: var(--text-primary);
}

.bg-gradient {
  background: linear-gradient(135deg, rgba(17, 115, 212, 0.95) 0%, rgba(40, 137, 235, 0.9) 100%);
}

.avatar-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

.form-control,
.form-select {
  background-color: var(--card-bg);
  color: var(--text-primary);
  border-color: rgba(148, 163, 184, 0.4);
  border-radius: 10px;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(17, 115, 212, 0.15);
  background-color: var(--card-bg);
}

.configuracion-usuarios.dark-theme .form-control,
.configuracion-usuarios.dark-theme .form-select {
  background-color: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.3);
  color: var(--text-primary);
}

.table {
  color: var(--text-primary);
}

.table thead th {
  border-color: var(--border-color);
}

.table tbody tr:hover {
  background-color: rgba(17, 115, 212, 0.04);
}
</style>
